<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors }"
    :mode="validateMode"
    slim
  >
    <vvs-control-wrapper
      :label="label"
      :is-required="isRequired"
      :error="errors[0]"
      :loading="loading"
    >
      <vue-recaptcha
        v-bind="recaptchaOptions"
        @verify="setGoogleVerifyKey"
        @expired="setGoogleVerifyKey(null)"
      ></vue-recaptcha>
      <input type="hidden" v-model="proxy" />
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'VvsRecaptcha',
  mixins: [formControlMixin],
  components: {
    VueRecaptcha,
  },
  computed: {
    recaptchaOptions() {
      return {
        sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_CLIENT_KEY,
        loadRecaptchaScript: true,
        theme: 'light',
        language: process.env.VUE_APP_DEFAULT_LOCALE_CODE,
        size: 'normal',
      };
    },
  },
  methods: {
    setGoogleVerifyKey(response) {
      this.proxy = response;
      this.onInput();
      this.$store.commit('setGoogleVerifyKey', response);
    },
  },
};
</script>
